<template>
    <div>
        <Header />
        <div class="container clearfix">

            <div class="users form upload" style="max-width: 400px; margin: 0 auto; height">
                <fieldset>
                    <legend>CSVアップロード</legend>
                    <p>物件データをアップロードしてください</p>
                    <label>
                        <span class="btn btn-primary">
                            アップロードする
                            <input type="file" accept=".csv, .txt" style="display:none" @change="onFileChange">
                        </span>
                    </label>
                    <p>{{ message }}</p>
                </fieldset>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../../components/Header/Header'

export default {
    components: {
        Header
    },
    data() {
        return {
            csv: ''
        }
    },
    mounted() {
        this.$store.commit('csv/setMessage', null)
    },
    computed: {
        message() {
            return this.$store.getters['csv/getMessage']
        }
    },
    methods: {
        onFileChange(e) {
            this.csv =  e.target.files[0]
            this.upload();
        },
        async upload() {
            await this.$store.dispatch('csv/uploadCsv', this.csv)
        }
    }
}
</script>


 <style scoped>
 .upload {
     position: absolute;
     top: 40%;
     left: 50%;
     transform: translate(-50%, -50%);
 }
 </style>